export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              关于本站
            </h2>
            <p className="text-sm text-foreground-500">
              了解51每日大赛的使命与价值
            </p>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-10">
            <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed space-y-4">
              <p>
                51每日大赛诞生于对每日大赛平台的深度热爱与长期使用经验。作为每日大赛资深用户社区的一员，我们深知用户在访问平台时面临的困扰——网址频繁变更、入口难以查找、APP下载渠道混乱。
              </p>
              <p>
                因此，我们创建了51每日大赛这个专注于每日大赛入口导航的服务平台。我们的使命很简单：为每一位每日大赛用户提供最可靠、最及时、最全面的访问解决方案。无论是官方网站入口、备用镜像地址还是多平台APP下载方式，我们都力求做到第一时间更新、验证和同步。
              </p>
              <p>
                自上线以来，51每日大赛已累计服务超过百万用户，帮助无数每日大赛爱好者解决了访问难题。我们坚持人工审核每一个入口的安全性，确保用户不会因误入虚假网站而遭受损失。同时，我们保持对官方动态的密切关注，做到入口更新零延迟。
              </p>
              <p>
                未来，51每日大赛将继续深耕每日大赛入口导航领域，不断优化服务体验，拓展更多实用功能，成为每日大赛用户心中最值得信赖的导航伙伴。
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-200/70">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">100万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计服务用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600">365天</div>
                <div className="text-xs text-foreground-500 mt-1">全年不间断更新</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">入口可用率</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600">3端</div>
                <div className="text-xs text-foreground-500 mt-1">全覆盖支持</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}